<?php

Namespace Model\Login;

class PageModel extends \Model\Base
{

    public $returned_data;

    public function getPage()
    {
        $page = array();
        $page['title'] = 'Login to your Video Interviews account';
        $page['heading'] = 'Video Interviews is waiting for you, come over and Login!';
        \ISOPHP\js_core::$console->log('Login Mod', $page);
        return $page;
    }

    public function getLoginResult($pageVars)
    {
        $vars['control'] = 'Login';
        $vars['action'] = 'attempt';
        $vars['api_uri'] = '/api/user/login';
        $jQuery = \ISOPHP\js_core::$jQuery;
        $vars['user'] = $jQuery('#email_username')->val();
        $vars['pass'] = $jQuery('#pass')->val();
        $afterwards = $this->applyLoginResult($pageVars);
        $result = $this->performRequest($vars, $afterwards);
        return $result;
    }

    public function applyLoginResult($pageVars)
    {
        $func = function ($request_data) use ($pageVars) {
            \ISOPHP\js_core::$console->log('applying our login result to', $request_data);
            \ISOPHP\js_core::$console->log('request data status', $request_data['status']);
            if ($request_data['status'] === 'OK') {
                \ISOPHP\js_core::$console->log('saying hello');
                $welcome_message = "Hello, " . $request_data['user']['full_name'];
                \Core\WindowMessage::showMessage($welcome_message, 'good');
                $navigate = new \Model\Navigate();
                $extra_params = $pageVars['params'];
                // $extra_params['user_logged'] = $request_data->user;
                $extra_params['user_logged']['user'] = $request_data['user'];
                $extra_params['user_logged']['user_uploads'] = $request_data['user_uploads'];
                $extra_params['user_logged']['user_details'] = $request_data['user_details'];

                $extra_params['user_logged']['user_skill'] = $request_data['user_skill'];
                $extra_params['user_logged']['user_education'] = $request_data['user_education'];
                $extra_params['user_logged']['user_certificate'] = $request_data['user_certificate'];
                $extra_params['user_logged']['user_skill'] = $request_data['user_skill'];



                $registry = \ISOPHP\core::$registry;
                \ISOPHP\js_core::$console->log('registry is ', $registry);
                \ISOPHP\js_core::$console->log('logged user to registry is ', $extra_params['user_logged']);
                $registry::setValue('user_logged', $extra_params['user_logged']);

                \ISOPHP\js_core::$console->log('apply login', $extra_params);
                \ISOPHP\js_core::$console->log('CHANGING SOMETHING', $extra_params);

                $navigate->route('Home', 'show', $extra_params, '/home');

            } else {

                $message = $request_data['message'];
                \ISOPHP\js_core::$console->log('saying ' . $message);
                \Core\WindowMessage::showMessage($message, 'bad');

            }
        };
        return $func;
    }

    public static function bindButtons()
    {
        return function () {
            if (ISOPHP_EXECUTION_ENVIRONMENT === 'UNITER') {
                \ISOPHP\js_core::$console->log('Binding buttons');
                $jQuery = \ISOPHP\js_core::$jQuery;
                $perform_login_pass_field = $jQuery('#pass');
                $perform_login = $jQuery('#perform-login');
                $perform_login->on('click', function () {
                    $navigate = new \Model\Navigate();

                    /* Notification regarding login disabled. */
                    // $login_disabled_message = "We're currently not open for login! Please register and we'll contact you as soon as we're open";
                    // \ISOPHP\js_core::$console->log('saying ' . $login_disabled_message);
                    // \Core\WindowMessage::showMessage($login_disabled_message, 'bad');

//                    $navigate->route('LandingPage', 'show', array(), '/') ;
                    $navigate->route('Login', 'attempt', array());
                });
                /**
                 * Login action on keyboard enter.
                 */
                $perform_login_pass_field->keypress(function ($e) use ($perform_login) {
                    if ($e->which == 13) {
                        $perform_login->click();
                        return false;
                    }
                });

                $cancel_login = $jQuery('#cancel-login');
                $cancel_login->on('click', function () {
                    $navigate = new \Model\Navigate();
                    $navigate->route('LandingPage', 'show', array(), '/');
                });
                $cancel_login = $jQuery('#go-register');
                $cancel_login->on('click', function () {
                    $navigate = new \Model\Navigate();
                    $navigate->route('Register', 'show', array(), '/register');
                });
            }
        };
    }

}


// WEBPACK FOOTER //
// app/Login/Model/LoginPageModel.php